
import React, { useState, useEffect } from 'react';
import { localAxiosDelete, localAxiosPut, localAxiosToken } from '../../../../Axios/axios';
import { useSelector } from 'react-redux';
import {
  Box,
  Typography,
  Paper,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Grid,
  Chip,
  FormControlLabel,
  Switch,
  CircularProgress,
  TablePagination,
  Card,
  CardContent,
  Divider,
  useTheme,
  alpha,
  Tooltip,
  Stack,
  Badge,
  Snackbar, 
  Popover,
  RadioGroup,
  Radio,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Event as EventIcon,
  FilterList as FilterListIcon,
  CalendarMonth as CalendarMonthIcon,
  Close as CloseIcon,
  LocationOn as LocationOnIcon,
  Business as BusinessIcon,
  Save as SaveIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  Public as PublicIcon,
  Celebration as CelebrationIcon,
  Warning as WarningIcon
} from '@mui/icons-material';
import { axiosInstance, localAxiosGet } from '../../../../Axios/axios';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import axios from 'axios';
import { enGB } from 'date-fns/locale';
import dayjs from 'dayjs';
import { CloudDownload as CloudDownloadIcon } from '@mui/icons-material';

const Toast = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const HolidayCalendar = () => {
  const theme = useTheme();
  const [holidays, setHolidays] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentHoliday, setCurrentHoliday] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedLocation, setSelectedLocation] = useState('');
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [holidayToDelete, setHolidayToDelete] = useState(null);
  const [selectDownloadformat, setSelectDownloadFormat] = useState('pdf');
  const [anchorEl, setAnchorEl] = useState(null);
  
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  const years = Array.from({ length: 5 }, (_, i) => selectedYear - 2 + i);
   const token = useSelector(state => state.auth.accessToken);
  const fetchLocations = async () => {
    try {
     
      const org_id = localStorage.getItem('organizationId') ;
      
      if (!token) {
        showToast("Authentication token not found. Please log in again.", "error");
        return;
      }
      
      const response = await axiosInstance(localAxiosGet(
        `/organization/getAllLocationsByOrgId/${org_id}`, 
        token
      ));
      
      if (response.data.status === "SUCCESS") {
        setLocations(response.data.message);
       
        const locationId = localStorage.getItem('locationId');
        const defaultLocation = response.data.message.find(loc => loc.id.toString() === locationId);
        if (defaultLocation) {
          setSelectedLocation(defaultLocation.location_name);
        }
      }
    } catch (err) {
      console.error("Error fetching locations:", err);
      showToast("Failed to load locations. Please try again later.", "error");
    }
  };

  const fetchHolidays = async () => {
    setLoading(true);
    try {
    
      const org_id = localStorage.getItem('organizationId');
      
      
      let location_Id;
      if (selectedLocation) {
        const selectedLoc = locations.find(loc => loc.location_name === selectedLocation);
        location_Id = selectedLoc ? selectedLoc.id : localStorage.getItem('locationId') || '1';
      } else {
        location_Id = localStorage.getItem('locationId') || '1';
      }
      
      if (!token) {
        showToast("Authentication token not found. Please log in again.", "error");
        setLoading(false);
        return;
      }
      
      const response = await axiosInstance(localAxiosGet(
        `/organization/getAllHolidaysByYearAndMonth?year=${selectedYear}&organization_id=${org_id}&location_id=${location_Id}`, 
        token
      ));
      
      if (response.data.status === "SUCCESS") {
        const formattedHolidays = response.data.message.holidays.map(holiday => {
          
          const applicableLocations = locations
            .filter(loc => holiday.location_ids?.includes(loc.id))
            .map(loc => loc.location_name);
          
          return {
            id: holiday.id,
            name: holiday.holiday_name,
            date: new Date(holiday.date),
            is_national: holiday.is_national,
            description: '',
            optional: false,
            location_ids: holiday.location_ids || [],
            applicableLocations: holiday.is_national ? ['All'] : (applicableLocations.length > 0 ? applicableLocations : ['All'])
          };
        });
        
        setHolidays(formattedHolidays);
        setPage(0); 
      }
    } catch (err) {
      console.error("Error fetching holidays:", err);
      showToast("Failed to load holidays. Please try again later.", "error");
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchLocations();
  }, []);
  
  useEffect(() => {
    if (locations.length > 0) {
      fetchHolidays();
    }
  }, [selectedYear, selectedLocation, locations]);
  
  const showToast = (message, severity = 'success') => {
    setToast({
      open: true,
      message,
      severity
    });
  };
  
  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast({ ...toast, open: false });
  };
  
  const handleOpenDialog = (holiday = null) => {
    if (holiday) {
      setCurrentHoliday({...holiday});
      setEditMode(true);
    } else {
      setCurrentHoliday({ 
        name: '', 
        date: new Date(), 
        description: '', 
        optional: false, 
        applicableLocations: ['All'],
        location_ids: [],
        is_national: true
      });
      setEditMode(false);
    }
    setDialogOpen(true);
  };
  
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentHoliday({ ...currentHoliday, [name]: value });
  };
  
  const handleDateChange = (newDate) => {
    setCurrentHoliday({ ...currentHoliday, date: newDate });
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCurrentHoliday({ ...currentHoliday, [name]: checked });
  };
  
  const handleLocationChange = (e) => {
    const selectedLocationNames = e.target.value;
    
    const isAllSelected = selectedLocationNames.includes('All');
    const wasAllSelected = currentHoliday?.applicableLocations?.includes('All');
    
    let newLocations;
    
    if (isAllSelected && !wasAllSelected) {
      newLocations = ['All'];
    } 
    else if (!isAllSelected && wasAllSelected) {
      newLocations = selectedLocationNames.filter(loc => loc !== 'All');
    }
    else if (wasAllSelected && selectedLocationNames.length > 1) {
      newLocations = selectedLocationNames.filter(loc => loc !== 'All');
    }
    else {
      newLocations = selectedLocationNames;
    }
    
    let location_ids = [];
    if (newLocations.includes('All')) {
      location_ids = locations.map(loc => loc.id);
    } else {
      location_ids = locations
        .filter(loc => newLocations.includes(loc.location_name))
        .map(loc => loc.id);
    }
    
    setCurrentHoliday({ 
      ...currentHoliday, 
      applicableLocations: newLocations,
      location_ids: location_ids,
      is_national: newLocations.includes('All')
    });
  };
  
  const handleSaveHoliday = async () => {
    try {
      setLoading(true);     
      
      const org_id = localStorage.getItem('organizationId') || '117';
      
      if (!token) {
        showToast("Authentication token not found. Please log in again.", "error");
        setLoading(false);
        return;
      }
      
      if (!currentHoliday.name.trim()) {
        showToast("Holiday name is required", "error");
        setLoading(false);
        return;
      }
      
      let location_ids = currentHoliday.location_ids;
      
      if (location_ids.length === 0 && locations.length > 0) {
        location_ids = locations.map(loc => loc.id);
      }
      
      const holidayData = {
        holiday_name: currentHoliday.name,
        date: currentHoliday.date.toISOString().split('T')[0], 
        organization_id: parseInt(org_id),
        location_ids: location_ids,
        is_national: currentHoliday.is_national
      };
      
      try {
        if (editMode && currentHoliday.id) {
          const endpoint = `/organization/updateHoliday/${currentHoliday.id}`;
          const config = localAxiosPut(endpoint, holidayData, token);
          const response = await axiosInstance(config);
          
          if (response.data && response.data.statusCode === 400) {
            showToast(response.data.message || "Failed to update holiday", "error");
            return;
          }
          
          showToast("Holiday updated successfully", "success");
        } else {
          const config = localAxiosToken('/organization/createHoliday', holidayData);
          const response = await axiosInstance(config);
          
          if (response.data && response.data.statusCode === 400) {
            showToast(response.data.message || "Failed to create holiday", "error");
            return;
          }
          
          showToast("Holiday created successfully", "success");
        }
        
        fetchHolidays();
        handleCloseDialog();
        
      } catch (apiError) {
        console.error("API Error:", apiError);
        
        if (apiError.response && apiError.response.data) {
          showToast(apiError.response.data.message || "API error occurred", "error");
        } else {
          showToast("Failed to communicate with the server. Please try again.", "error");
        }
      }
      
    } catch (err) {
      console.error("Error saving holiday:", err);
      showToast("Failed to save holiday. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };
  
  const handleDeleteConfirmation = (holiday) => {
    setHolidayToDelete(holiday);
    setDeleteDialogOpen(true);
  };

  const handleCancelDelete = () => {
    setDeleteDialogOpen(false);
    setHolidayToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (!holidayToDelete || !holidayToDelete.id) return;
    
    try {
      setLoading(true);     
      
      
      if (!token) {
        showToast("Authentication token not found. Please log in again.", "error");
        setLoading(false);
        return;
      }
      
      const endpoint = `/organization/deleteHoliday/${holidayToDelete.id}`;
      const config = localAxiosDelete(endpoint, token);
      const response = await axiosInstance(config);
      
      if (response.data && response.data.statusCode === 400) {
        showToast(response.data.message || "Failed to delete holiday", "error");
        return;
      }
      
      showToast("Holiday deleted successfully", "success");
      fetchHolidays();
      
    } catch (err) {
      console.error("Error deleting holiday:", err);
      
      if (err.response && err.response.data) {
        showToast(err.response.data.message || "API error occurred", "error");
      } else {
        showToast("Failed to delete holiday. Please try again.", "error");
      }
    } finally {
      setLoading(false);
      setDeleteDialogOpen(false);
      setHolidayToDelete(null);
    }
  };
  
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };
  
  const handleLocationFilterChange = (e) => {
    setSelectedLocation(e.target.value);
  };
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  const filteredHolidays = holidays.filter(holiday => {
   
    if (!selectedLocation) return true;
    
    
    if (holiday.applicableLocations.includes('All')) return true;
    
    
    return holiday.applicableLocations.includes(selectedLocation);
  });
  
  const sortedHolidays = [...filteredHolidays].sort((a, b) => a.date - b.date);
  
  const paginatedHolidays = sortedHolidays.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  
  const getDayName = (date) => {
    return date.toLocaleDateString('en-US', { weekday: 'long' });
  };
  
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');       
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = String(date.getFullYear()).slice(-2);        
  
    return `${day}/${month}/${year}`; 
  };
  
  
  const handleEditHoliday = (holiday) => {
    setCurrentHoliday({...holiday});
    setEditMode(true);
    setDialogOpen(true);
  };
  
    
  const getCurrentLocationName = () => {
    const locationId = localStorage.getItem('locationId');
    const location = locations.find(loc => loc.id.toString() === locationId);
    return location ? location.location_name : 'All Locations';
  };

  const handleOpenDownloadFormatDialog = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFormatChange = (event) => {
    setSelectDownloadFormat(event.target.value);
  };

  const handleDownloadCalendar = async () => {
    try {
     
      const orgId = localStorage.getItem('organizationId');
      const locId = localStorage.getItem('locationId');
      const currentYear = dayjs().year(); 

      if (!token || !orgId) {
        showToast("Authentication token or organization ID not found", "error");
        return;
      }

      const endpoint = selectDownloadformat === 'excel'
        ? `/organization/getHolidayListExcel?year=${currentYear}&location_id=${locId}&organization_id=${orgId}`
        : `/organization/getHolidayListPDF?year=${currentYear}&location_id=${locId}&organization_id=${orgId}`;

      const response = await axiosInstance({
        ...localAxiosGet(endpoint, token),
        responseType: 'blob'
      });

      if (!(response.data instanceof Blob)) {
        throw new Error('Response data is not a Blob');
      }

      const contentType = response.headers['content-type'] ||
        (selectDownloadformat === 'excel'
          ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          : 'application/pdf');
      
      const extension = selectDownloadformat === 'excel' ? 'xlsx' : 'pdf';
      const filename = `holiday_calendar_${currentYear}.${extension}`;
      
      const contentDisposition = response.headers['content-disposition'];
      const finalFilename = contentDisposition && contentDisposition.match(/filename="?(.+)"?/)
        ? contentDisposition.match(/filename="?(.+)"?/)[1]
        : filename;

      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = finalFilename;
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      showToast("Download started successfully!", "success");
      handleClosePopover();

    } catch (error) {
      console.error('Download failed:', error);
      showToast("Failed to download. Please try again", "error");
    }
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const popoverOpen = Boolean(anchorEl);

  return (
    <Box sx={{ 
      padding: 3, 
      backgroundColor: alpha(theme.palette.background.default, 0.5),
      minHeight: '100vh'
    }}>
      <Card 
        elevation={0} 
        sx={{ 
          mb: 3, 
          borderRadius: 2,
          background: 'linear-gradient(135deg, #42a5f5 0%, #1976d2 100%)',
          color: 'white',
          overflow: 'hidden'
        }}
      >
        <CardContent sx={{ py: 3 }}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <CalendarMonthIcon sx={{ fontSize: 40, opacity: 0.9 }} />
            </Grid>
            <Grid item xs>
              <Typography variant="h5" fontWeight={600}>
                Holiday Calendar
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
                Manage and view holidays for your organization
              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => handleOpenDialog()}
                disabled={loading}
                sx={{ 
                  bgcolor: 'rgba(255, 255, 255, 0.2)', 
                  color: 'white', 
                  '&:hover': { 
                    bgcolor: 'rgba(255, 255, 255, 0.3)', 
                  }, 
                  borderRadius: 2, 
                  boxShadow: 'none', 
                  px: 2 
                }}
              >
                Add Holiday
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      
      <Card 
        elevation={0}
        sx={{ 
          mb: 3, 
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden'
        }}
      >
        <CardContent sx={{ py: 2 }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <EventIcon sx={{ color: theme.palette.primary.main, mr: 1 }} />
                <FormControl fullWidth size="small">
                  <InputLabel>Year</InputLabel>
                  <Select
                    value={selectedYear}
                    onChange={handleYearChange}
                    label="Year"
                    disabled={loading}
                    sx={{ 
                      borderRadius: 1,
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.primary.main, 0.3),
                      }
                    }}
                  >
                    {years.map(year => (
                      <MenuItem key={year} value={year}>{year}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <LocationOnIcon sx={{ color: theme.palette.info.main, mr: 1 }} />
                <FormControl fullWidth size="small">
                  <InputLabel>Location</InputLabel>
                  <Select
                    value={selectedLocation}
                    onChange={handleLocationFilterChange}
                    label="Location"
                    disabled={loading}
                    sx={{ 
                      borderRadius: 1,
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: alpha(theme.palette.info.main, 0.3),
                      }
                    }}
                  >
                   
                    {locations.map(location => (
                      <MenuItem key={location.id} value={location.location_name}>
                        {location.location_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Stack direction="row" spacing={1}>
                  <Tooltip title="Export Holidays">
                    <IconButton 
                      size="small"
                      sx={{ 
                        color: theme.palette.primary.main,
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.2) }
                      }}
                      onClick={handleOpenDownloadFormatDialog}
                    >
                      <CloudDownloadIcon />
                    </IconButton>
                  </Tooltip>
                  
                  <Popover
                    open={popoverOpen}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <Box sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 2,
                      minWidth: 200
                    }}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          aria-label="download-format"
                          name="download-format-group"
                          value={selectDownloadformat}
                          onChange={handleFormatChange}
                        >
                          <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
                          <FormControlLabel value="excel" control={<Radio />} label="Excel" />
                        </RadioGroup>
                      </FormControl>
                      <Button
                        onClick={handleDownloadCalendar}
                        variant="contained"
                        startIcon={<CloudDownloadIcon />}
                        size="small"
                      >
                        Download
                      </Button>
                    </Box>
                  </Popover>

                  {/* <Tooltip title="Print Calendar"> 
                    <IconButton 
                      size="small"
                      sx={{ 
                        color: theme.palette.info.main,
                        bgcolor: alpha(theme.palette.info.main, 0.1),
                        '&:hover': { bgcolor: alpha(theme.palette.info.main, 0.2) }
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
                    </IconButton>
                  </Tooltip> */}
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      
      <Card 
        elevation={0} 
        sx={{ 
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          overflow: 'hidden'
        }}
      >
        <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}`, bgcolor: alpha(theme.palette.primary.main, 0.03) }}>
          <Typography variant="h6" fontWeight={600} color="primary.main">
            {selectedYear} Holidays {selectedLocation ? `- ${selectedLocation}` : ''}
          </Typography>
        </Box>
        
        <TableContainer>
          <Table aria-label="holiday table">
            <TableHead sx={{ bgcolor: alpha(theme.palette.primary.main, 0.05) }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.primary }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.primary }}>Day</TableCell>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.primary }}>Holiday</TableCell>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.primary }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 600, color: theme.palette.text.primary }}>Applicable Locations</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600, color: theme.palette.text.primary }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
                    <CircularProgress size={40} sx={{ color: theme.palette.primary.main }} />
                    <Typography variant="body1" sx={{ mt: 2, color: theme.palette.text.secondary }}>
                      Loading holidays...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : paginatedHolidays.length > 0 ? (
                paginatedHolidays.map((holiday, index) => (
                  <TableRow
                    key={holiday.id || index}
                    hover
                    sx={{ 
                      '&:hover': { bgcolor: alpha(theme.palette.primary.main, 0.03) },
                      transition: 'background-color 0.2s'
                    }}
                  >
                    <TableCell>
                      <Typography variant="body2" fontWeight={500}>
                        {formatDate(holiday.date)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={getDayName(holiday.date)}
                        size="small"
                        sx={{
                          bgcolor: alpha(theme.palette.grey[500], 0.1),
                          color: theme.palette.text.secondary,
                          fontWeight: 500,
                          borderRadius: 1
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={500}>
                        {holiday.name}
                      </Typography>
                      {holiday.description && (
                        <Typography variant="caption" color="text.secondary">
                          {holiday.description}
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell>
                      <Chip
                        icon={holiday.is_national ? <PublicIcon fontSize="small" /> : <LocationOnIcon fontSize="small" />}
                        label={holiday.is_national ? "National" : "Regional"}
                        size="small"
                        sx={{
                          backgroundColor: holiday.is_national 
                            ? alpha(theme.palette.primary.main, 0.1)
                            : alpha(theme.palette.info.main, 0.1),
                          color: holiday.is_national 
                            ? theme.palette.primary.main
                            : theme.palette.info.main,
                          fontWeight: 500,
                          '& .MuiChip-icon': {
                            color: 'inherit'
                          }
                        }}
                      />
                      {holiday.optional && (
                        <Chip
                          label="Optional"
                          size="small"
                          sx={{
                            ml: 1,
                            bgcolor: alpha(theme.palette.warning.main, 0.1),
                            color: theme.palette.warning.dark,
                            fontWeight: 500
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {holiday.applicableLocations.map(location => (
                          <Chip 
                            key={location} 
                            label={location} 
                            size="small" 
                            variant="outlined"
                            sx={{
                              borderColor: alpha(theme.palette.primary.main, 0.3),
                              color: theme.palette.text.secondary,
                              fontSize: '0.75rem'
                            }}
                          />
                        ))}
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Tooltip title="Edit">
                          <IconButton 
                            size="small" 
                            color="primary"
                            onClick={() => handleEditHoliday(holiday)}
                            sx={{ 
                              mr: 1,
                              '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.1) } 
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        
                        <Tooltip title="Delete">
                          <IconButton 
                            size="small" 
                            color="error"
                            onClick={() => handleDeleteConfirmation(holiday)}
                            sx={{ 
                              '&:hover': { backgroundColor: alpha(theme.palette.error.main, 0.1) } 
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 5 }}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      p: 3
                    }}>
                      <CalendarMonthIcon sx={{ fontSize: 60, color: alpha(theme.palette.text.secondary, 0.4), mb: 2 }} />
                      <Typography variant="h6" color="text.secondary" gutterBottom>
                        No holidays found
                      </Typography>
                      <Typography variant="body2" color="text.secondary" align="center" sx={{ maxWidth: 500, mb: 2 }}>
                        There are no holidays configured for the selected year. Click the "Add Holiday" button to create a new holiday.
                      </Typography>
                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={() => handleOpenDialog()}
                        sx={{ borderRadius: 2, mt: 1 }}
                      >
                        Add Holiday
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={sortedHolidays.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Holidays per page:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} of ${count}`}
            sx={{ 
              borderTop: `1px solid ${theme.palette.divider}`,
              '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                margin: 0
              }
            }}
          />
        </TableContainer>
      </Card>
      
     
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'visible' 
          }
        }}
      >
        <DialogTitle sx={{ 
  bgcolor: editMode ? theme.palette.primary.main : theme.palette.success.main,
  color: 'white',
  py: 2
}}>
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {editMode ? <EditIcon sx={{ mr: 1 }} /> : <AddIcon sx={{ mr: 1 }} />}
      <Typography variant="h6">
        {editMode ? 'Edit Holiday' : 'Add New Holiday'}
      </Typography>
    </Box>
    <IconButton 
      size="small" 
      onClick={handleCloseDialog}
      sx={{ color: 'white' }}
    >
      <CloseIcon />
    </IconButton>
  </Box>
</DialogTitle>

<Box sx={{ height: 16 }} />

<DialogContent sx={{ 
  py: 4,    
  px: 3,    
}}>
  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
    <Grid container spacing={4}> 
      <Grid item xs={12} md={6}>
        <TextField
          name="name"
          label="Holiday Name"
          value={currentHoliday?.name || ''}
          onChange={handleInputChange}
          inputFormat="dd/MM/yyyy"
          fullWidth
          required
          variant="outlined"
          placeholder="Enter holiday name"
          InputProps={{
            startAdornment: (
              <EventIcon color="action" sx={{ mr: 1 }} />
            ),
          }}
          sx={{
            mb: 1,  
            '& .MuiOutlinedInput-root': {
              borderRadius: 1
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DatePicker
          label="Holiday Date"
          value={currentHoliday?.date || null}
          onChange={handleDateChange}
          renderInput={(params) => (
            <TextField 
              {...params} 
              fullWidth
              required
              sx={{
                mb: 1,  
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1
                }
              }}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth sx={{ mb: 1 }}>
          <InputLabel>Applicable Locations</InputLabel>
          <Select
            multiple
            value={currentHoliday?.applicableLocations || []}
            onChange={handleLocationChange}
            label="Applicable Locations"
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} size="small" />
                ))}
              </Box>
            )}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 250
                }
              }
            }}
            sx={{
              borderRadius: 1
            }}
          >
            <MenuItem value="All">
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <PublicIcon fontSize="small" sx={{ mr: 1, color: theme.palette.primary.main }} />
                All Locations
              </Box>
            </MenuItem>
            {locations.map(location => (
              <MenuItem key={location.id} value={location.location_name}>
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <LocationOnIcon fontSize="small" sx={{ mr: 1, color: theme.palette.info.main }} />
                  {location.location_name}
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <TextField
          name="description"
          label="Description (Optional)"
          value={currentHoliday?.description || ''}
          onChange={handleInputChange}
          fullWidth
          multiline
          rows={3}
          placeholder="Add any additional details about this holiday"
          sx={{
            mb: 1,  
            '& .MuiOutlinedInput-root': {
              borderRadius: 1
            }
          }}
        />
      </Grid>
    </Grid>
  </LocalizationProvider>
</DialogContent>

<Box sx={{ height: 8 }} />

<DialogActions sx={{ 
  px: 3, 
  py: 3,  
  borderTop: 1,  
  borderColor: 'divider',  
  bgcolor: alpha(theme.palette.background.default, 0.5)
}}>
  <Button 
    onClick={handleCloseDialog} 
    color="inherit" 
    disabled={loading}
    startIcon={<CloseIcon />}
    sx={{ 
      borderRadius: 2,
      textTransform: 'none',
      px: 3,  
      mr: 2   
    }}
  >
    Cancel
  </Button>
  <Button 
    onClick={handleSaveHoliday} 
    variant="contained" 
    color={editMode ? "primary" : "success"}
    disabled={loading}
    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
    sx={{ 
      borderRadius: 2,
      px: 3,  
      textTransform: 'none'
    }}
  >
    {loading ? 'Saving...' : (editMode ? 'Update Holiday' : 'Save Holiday')}
  </Button>
</DialogActions>
</Dialog>


<Dialog
  open={deleteDialogOpen}
  onClose={handleCancelDelete}
  maxWidth="xs"
  fullWidth
  PaperProps={{
    sx: {
      borderRadius: 2,
      overflow: 'hidden'
    }
  }}
>
  <DialogTitle sx={{ 
    bgcolor: theme.palette.error.main,
    color: 'white',
    py: 2
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <WarningIcon sx={{ mr: 1 }} />
      <Typography variant="h6">Delete Holiday</Typography>
    </Box>
  </DialogTitle>
  <DialogContent sx={{ pt: 3, pb: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
      <CalendarMonthIcon color="error" sx={{ fontSize: 40, mr: 2, opacity: 0.7 }} />
      <Box>
        <Typography variant="subtitle1" fontWeight={500}>
          Are you sure you want to delete this holiday?
        </Typography>
        {holidayToDelete && (
          <Typography variant="body2" color="text.secondary">
            {holidayToDelete.name} - {formatDate(holidayToDelete.date)}
          </Typography>
        )}
      </Box>
    </Box>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
      This action cannot be undone. The holiday will be permanently removed from the system.
    </Typography>
  </DialogContent>
  <DialogActions sx={{ 
    px: 3, 
    py: 2,
    borderTop: 1,
    borderColor: 'divider',
    bgcolor: alpha(theme.palette.background.default, 0.5)
  }}>
    <Button 
      onClick={handleCancelDelete}
      color="inherit"
      disabled={loading}
      sx={{ 
        borderRadius: 2,
        textTransform: 'none'
      }}
    >
      Cancel
    </Button>
    <Button 
      onClick={handleConfirmDelete}
      variant="contained"
      color="error"
      disabled={loading}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon />}
      sx={{ 
        borderRadius: 2,
        textTransform: 'none'
      }}
    >
      {loading ? 'Deleting...' : 'Delete Holiday'}
    </Button>
  </DialogActions>
</Dialog>


<Snackbar 
  open={toast.open} 
  autoHideDuration={6000} 
  onClose={handleCloseToast}
  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
>
  <Toast 
    onClose={handleCloseToast} 
    severity={toast.severity} 
    sx={{ width: '100%' }}
  >
    {toast.message}
  </Toast>
</Snackbar>
</Box>
);
};

export default HolidayCalendar;